import { inject, Injectable } from '@angular/core';
import { ApiHelper, ApiService, HttpResponse } from '@core/api';
import { AutosuggestMapper } from './autosuggest.mapper';

@Injectable({
    providedIn: 'root',
})
export class AutosuggestApiService {
    private apiService = inject(ApiService);

    suggestUsers(payload: {
        searchValue: string;
        take: number;
        skip: number;
    }): Promise<HttpResponse<{ id: number; name: string; email: string }[]>> {
        return new Promise<HttpResponse<{ id: number; name: string; email: string }[]>>(resolve => {
            this.apiService.post(`autosuggest/suggest-users`, payload).subscribe({
                next: (res: any) => {
                    resolve(AutosuggestMapper.mapAutosuggestUsers(res));
                },
                error: err => {
                    ApiHelper.resolveError(resolve, err?.error?.message);
                    console.error(err);
                },
            });
        });
    }
}
